import { render } from "./HeroiconsSolidInboxIn.vue?vue&type=template&id=a4729874"
const script = {}

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidInboxIn.vue"]])

export default __exports__